<template>
  <div v-if="getRoute() != 'signIn'" class="agent-app-header">
    <navbar is-blur="blur start-0 end-0 shadow" btn-background="bg-gradient-success" :dark-mode="true" />
  </div>
  <main
    v-loading="loading"
    class="not-for-print main-content app-main-content position-relative max-height-vh-100 h-100"
    :class="{ 'app-main-content--no-footer': hideFooter }"
  >
    <router-view @set-loading="setLoading" />
    <app-footer v-if="showFooter" />
  </main>
</template>

<script>
import Navbar from "@/examples/PageLayout/Navbar.vue";
import AppFooter from "@/examples/Footer.vue";
import CryptoJS from "crypto-js";

export default {
  name: "App",
  components: {
    Navbar,
    AppFooter,
  },
  data() {
    return {
      loading: false,
    };
  },

  computed: {
    hideFooter() {
      const path = this.$route?.path || "";
      if (path === "/reports" || path.startsWith("/reports/")) return true;
      if (path.startsWith("/catalog/insert")) return true;
      return false;
    },
    showFooter() {
      return this.getRoute() !== "signIn" && !this.hideFooter;
    },
  },
  created() {
    if (window.localStorage.getItem("jwt") === null) {
      window.localStorage.setItem(
        "jwt",
        CryptoJS.AES.encrypt(JSON.stringify("none"), "secret_key").toString()
      );
      window.localStorage.setItem(
        "roles",
        CryptoJS.AES.encrypt(JSON.stringify([{ id: null }]), "secret_key").toString()
      );
      window.localStorage.setItem(
        "user",
        CryptoJS.AES.encrypt(JSON.stringify([{ id: null }]), "secret_key").toString()
      );
    }
    this.$store.state.isTransparent = "bg-white";
  },
  mounted() {
    const sidenavShow = document.querySelector(".g-sidenav-show");
    if (!sidenavShow) return;
    if (JSON.parse(window.localStorage.getItem("sidenavPin"))) {
      sidenavShow.classList.remove("g-sidenav-hidden");
      sidenavShow.classList.add("g-sidenav-pinned");
    } else {
      sidenavShow.classList.add("g-sidenav-hidden");
      sidenavShow.classList.remove("g-sidenav-pinned");
    }
  },
  methods: {
    getRoute() {
      return this.$route.path.split("/")[1];
    },
    setLoading(value) {
      this.loading = Boolean(value);
    },
  },
};
</script>

<style>
.agent-app-header {
  position: relative;
  z-index: 1020;
  background: var(--agent-main-bg, #05070d);
}

.app-main-content {
  padding-bottom: 20px;
  background: var(--agent-main-bg, #05070d);
  overflow-x: hidden;
}

.app-main-content.app-main-content--page-scroll {
  overflow-y: auto;
}

.app-main-content--no-footer {
  padding-bottom: 0;
}
</style>
